import { Component, OnInit, Renderer2, ElementRef, ViewChild, Input, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StepService } from 'src/app/services/step.service';

@Component({
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss'],
})
export class ProgressbarComponent implements OnInit, AfterViewInit {
  progressPercentage: number;

  constructor(
    private renderer2: Renderer2,
    private stepService: StepService
  ) {}

  private unsubscribe: Subject<void> = new Subject();

  @Input() public step: number;
  @Input() public maxStep: number;

  @ViewChild('progressBar') progressBar: ElementRef;
  @ViewChild('totalBar') totalBar: ElementRef;

  ngAfterViewInit() {
    this.stepService.stepChange$.subscribe(newStep => {
      this.processStepChangeEvent(newStep);
    });

    this.setProgress();
  }

  processStepChangeEvent(newStep: number) {
    if (newStep > 0 && newStep <= this.maxStep) {
      this.step = newStep;
      this.setProgress();
    }
  }

  ngOnInit() {}

  setProgress() {
    this.progressPercentage = this.step / this.maxStep;

    if (this.progressBar) {
      this.renderer2.setStyle(
        this.progressBar.nativeElement,
        'width',
        this.progressPercentage * this.totalBar.nativeElement.clientWidth + 'px'
      );
    }
  }
}
